module.exports = __webpack_public_path__ + "img/left-arrow.240705ac.svg";